import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const YupValidate = () => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    work_name: Yup.string().trim().required(t('messages.thisIsARequiredField')),
    hr_date_log: Yup.string().required(t('messages.thisIsARequiredField')),
    project_id: Yup.string().required(t('messages.thisIsARequiredField')),
    hr_start_time_log: Yup.string().required(t('messages.thisIsARequiredField')).nullable(),
    hr_end_time_log: Yup.string().required(t('messages.thisIsARequiredField')).nullable(),
    next_person: Yup.array().min(1, t('messages.thisIsARequiredField')).required(t('messages.thisIsARequiredField')),
  });
  return validationSchema;
};
